export default __webpack_public_path__ + "static/media/generalOverview.a8f45838.png";